import ES6Promise from "es6-promise"
import axios from 'axios'
import { getContextPath, Time } from 'utils'
import messageApi from './messagebox'
import Vue from 'vue'

if(!window.Promise) {
  ES6Promise.polyfill();
}

// 创建实例
const service = axios.create({
  baseURL: getContextPath(),
  timeout: 1000 * 60,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    "Content-Type": "application/x-www-form-urlencoded;",
  },
  // 只能用在 'PUT', 'POST' 和 'PATCH' 这几个请求方法
  transformRequest: [function (data) {
    if (!data) return '';
    let pairs = [], value;
    for (let name in data) {
      if (!Object.prototype.hasOwnProperty.call(data, name)) continue;
      if (typeof data[name] === 'function') continue;
      value = String(data[name]);
      name = encodeURIComponent(name);
      value = encodeURIComponent(value);
      pairs.push(name + '=' + value);
    }
    if (pairs.length) {
      return pairs.join('&');
    } else {
      return ''
    }
  }],
  transformResponse: [ data => {
    return data;
  }],
  responseType: 'json'
})

// request拦截器
service.interceptors.request.use(function (config) {
  config.params = config.params || {};
  config.params._ = Time();
  return config;
}, function (error) {
  return Promise.reject(error);
});


// respone拦截器
service.interceptors.response.use(
  response => {
    // IE 9 
    if (response.data == null && response.config.responseType === 'json' && response.request.responseText != null) {
      try {
        // eslint-disable-next-line no-param-reassign
        response.data = JSON.parse(response.request.responseText);
      } catch (e) {
        // ignored
      }
    } else if (response.data != null && typeof response.data == 'string') { // IE10,11
      response.data = JSON.parse(response.data);
    }
    
    if(response && response.config && response.config.flag === 'whole') {
      // 针对toolbar返回值兼容，兼容标识config.flag === 'whole'
      return [response.data, response];
    } else {
      return response.data;
    }
  },
  error => {
    console.error('err' + error) // for debug
    messageApi(Vue.prototype.$LocalH5('requestFailed'), 'error')
    return Promise.reject(error)
  }
)

export default service